


























import VueOptions from '@utils/VueOptions'

settings = 
  name: 'EventTeamSection'
  vue:
    props: ['event', 'canEdit']
    
export default VueOptions.vue settings
